import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { IContent } from '@/cms/definitions/content';
import ContentComponentSelector from '@/cms/components/infrastructure/contentComponentSelector/ContentComponentSelector.vue';
import getComponentTypeForContent from '@/cms/api/contentComponentSelector';

const ignoreBlocksInUi = new Set([
	'UsabillaInPageBlock',
	'HeaderCardBlock',
	'HtmlBlock',
	'CampaignPackagesBlock',
	'CampaignFlatRateBlock',
	'AlertBlock',
]);
@Options({
	name: 'ContentAreaComponent',
	components: {
		ContentComponentSelector,
	},
	props: {
		model: Array as PropType<IContent[]>,
		rootClass: { type: String, default: 'ContentArea' },
		itemClass: { type: String, default: 'ContentAreaItem' },
	},
})
export default class ContentAreaComponent extends Vue {
	model!: IContent[];
	rootClass: string;
	itemClass: string;

	created(): void {
		this.model.forEach((block) => {
			block.hide = this.hideBlock(block);
		});
	}
	getComponentTypeForBlock(block: IContent) {
		return getComponentTypeForContent(block);
	}

	public hideBlock(block: IContent) {
		if (ignoreBlocksInUi.has(block.contentType)) {
			return true;
		}
		return false;
	}

	getBlockClasses(block: IContent) {
		const clzz = (block as any)?.containerClass ? (block as any).containerClass : '';
		return `${this.itemClass} ${clzz}`;
	}
}
